module.exports = __webpack_public_path__ + "static/img/son3.4c0e1ae7.png";